export default __webpack_public_path__ + "static/employee-wellbeing-mobile-banner-7278a66fe91fdce517d36e52e0f3e869.png";